const STORAGE_KEY = 'nf_mp_guest_wishlist';

function readSlugs() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return [...new Set(parsed.filter((s) => typeof s === 'string' && s.trim()))];
  } catch {
    return [];
  }
}

function writeSlugs(slugs) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify([...new Set(slugs)]));
  window.dispatchEvent(new Event('nf-guest-wishlist-changed'));
}

export function getGuestWishlistSlugs() {
  return readSlugs();
}

export function isGuestWishlisted(slug) {
  if (!slug) return false;
  return readSlugs().includes(slug);
}

export function addGuestWishlistSlug(slug) {
  if (!slug) return readSlugs();
  const next = readSlugs();
  if (!next.includes(slug)) next.unshift(slug);
  writeSlugs(next.slice(0, 100));
  return readSlugs();
}

export function removeGuestWishlistSlug(slug) {
  if (!slug) return readSlugs();
  writeSlugs(readSlugs().filter((s) => s !== slug));
  return readSlugs();
}

export function clearGuestWishlist() {
  localStorage.removeItem(STORAGE_KEY);
}
